import { DirectiveOptions } from "vue";
import { DirectiveBinding } from "vue/types/options";
import { Getter } from "vuex-class";
import { Language } from "@/models/Language";
function setPosition(element: HTMLElement, binding: DirectiveBinding) {
    const width = window.innerWidth;
    const height = window.innerHeight;

    const booths = element.querySelectorAll(".booth");
    const textContainers = element.querySelectorAll(".text-container");

    for (let i = 0; i < booths.length; i++) {
        const booth = booths[i] as HTMLElement;
        const textContainer = textContainers[i] as HTMLElement;

        let boothWidth = 0.17;
        let positionX = 0.18;
        let positionY = 0.17;

        switch (i) {
            case 0:
                boothWidth = 0.20;
                (document.dir == 'rtl' ? positionX = 0.29 : positionX = 0.24)
                positionY = 0.21;
                break;
            case 1:
                boothWidth = 0.20;
                (document.dir == 'rtl' ? positionX = 0.24 : positionX = 0.26)
                positionY = 0.21;
                break;
            case 2:
                boothWidth = 0.25;
                (document.dir == 'rtl' ? positionX = 0.22 : positionX = 0.18)
                positionY = 0.34;
                break;
            case 3:
                boothWidth = 0.25;
                (document.dir == 'rtl' ? positionX = 0.18 : positionX = 0.19)
                positionY = 0.34;
                break;
            case 4:
                boothWidth = 0.34;
                positionX = 0.04;
                (document.dir == 'rtl' ? positionX = 0.13 : positionX = 0.09)
                positionY = 0.50;
                break;
            case 5:
                boothWidth = 0.34;
                (document.dir == 'rtl' ? positionX = 0.09 : positionX = 0.09)
                positionY = 0.50;
                break;
        }

        let isLtr = true;
        if (document.dir == 'rtl') {
            isLtr = false;
        }

        const classList = booth.classList;
        let name = '';
        let boothType = '';
        if (classList.contains('game-booth')) {
            boothType = 'game-booth';
            classList.forEach((cls) => {
                if (cls.includes('gamename-')) {
                    name = cls.replace('gamename-', '');
                }
            })
        } else if(classList.contains('lesson-booth')){
            boothType = 'lesson-booth';
            classList.forEach((cls) => {
                if (cls.includes('lessoncode-')) {
                    name = cls.replace('lessoncode-', '');
                }
            })
        }else{
            boothType = 'interactive-booth';
            classList.forEach((cls) => {
                if (cls.includes('lessoncode-')) {
                    name = cls.replace('lessoncode-', '');
                }
            })
        }

        booth.style.border = "1px solid black;"

        if (i % 2 == 0) {
            booth.style.width = boothWidth * width + "px"; booth.style.width
            booth.style.height = boothWidth * width * 0.45 + "px";

            // textContainer.style.opacity = "0.2";


            if (isLtr) {
                booth.style['left'] = (positionX * width) + "px";
                booth.style.backgroundImage = `url("/assets/booths/${boothType}_l.png")`;
                textContainer.style.backgroundImage = `url("/assets/booths/${name}_lr_en.png")`;
                booth.style.backgroundPositionX = 'left';
                textContainer.style.backgroundPositionX = 'left';

                booth.addEventListener('mouseover', function () {
                    textContainer.style.backgroundPositionY = "102%";
                });
                booth.addEventListener('mouseout', function () {
                    textContainer.style.backgroundPositionY = "top";
                });
            } else {
                booth.style['right'] = positionX * width + "px";
                booth.style.backgroundPosition = 'right';
                booth.style.backgroundImage = `url("/assets/booths/${boothType}_r.png")`;
                textContainer.style.backgroundImage = `url("/assets/booths/${name}_rl_ar.png")`;
                textContainer.style.backgroundPositionX = 'right';

                booth.addEventListener('mouseover', function () {
                    textContainer.style.backgroundPositionY = "102%";
                });
                booth.addEventListener('mouseout', function () {
                    textContainer.style.backgroundPositionY = "top";
                });
            }
            booth.style.top = positionY * height + "px";

        } else {
            booth.style.width = boothWidth * width + "px";
            booth.style.height = boothWidth * width * 0.45 + "px";

            if (isLtr) {
                booth.style['left'] = width - (positionX * width + boothWidth * width) + "px";
                booth.style.backgroundImage = `url("/assets/booths/${boothType}_r.png")`;
                textContainer.style.backgroundImage = `url("/assets/booths/${name}_rl_en.png")`;

                booth.addEventListener('mouseover', function () {
                    textContainer.style.backgroundPositionY = "102%";
                });
                booth.addEventListener('mouseout', function () {
                    textContainer.style.backgroundPositionY = "top";
                });
            } else {
                booth.style['right'] = width - (positionX * width + boothWidth * width) + "px";
                booth.style.backgroundImage = `url("/assets/booths/${boothType}_l.png")`;
                textContainer.style.backgroundImage = `url("/assets/booths/${name}_lr_ar.png")`;
                textContainer.style.backgroundPositionX = 'left';
                booth.style.backgroundPositionX = 'left';

                booth.addEventListener('mouseover', function () {
                    textContainer.style.backgroundPositionY = "102%";
                });
                booth.addEventListener('mouseout', function () {
                    textContainer.style.backgroundPositionY = "top";
                });
            }
            booth.style.top = positionY * height + "px";
        }

    }
}



const boothsPositionsDirective: DirectiveOptions = {
    inserted(el, binding) {
        setPosition(el, binding);
    },
    update(el, binding) {
        setPosition(el, binding);
    },

};


export default boothsPositionsDirective;
